import { useEffect } from "react";
import { useAppDispatch } from "../../app/hooks";
import { refreshDeviceCalendarEntries } from "../../features/calendar/scheduleItem.thunk";

// Dispatched by the app (DaexWebView) when it comes back to the foreground
export const NATIVE_RESUME_EVENT = "daex:native-resume";

/**
 * Reloads the phone's calendar events when the app comes back to the
 * foreground - they may have been changed in the system calendar meanwhile.
 * Render once, inside the app only.
 */
function NativeDeviceCalendarSync() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const refresh = () => dispatch(refreshDeviceCalendarEntries());
    window.addEventListener(NATIVE_RESUME_EVENT, refresh);
    return () => window.removeEventListener(NATIVE_RESUME_EVENT, refresh);
  }, []);

  return null;
}

export default NativeDeviceCalendarSync;
